import { createFileRoute, redirect } from '@tanstack/react-router';
import ExternalDisplayEditor from 'containers/ExternalDisplayEditor/Loadable';
import { currentUserQueryOptions } from 'containers/User/hooks/useUserAccountSync';
import { getAuthtoken } from 'stores/useAuthStore';

export const Route = createFileRoute('/_authenticated/externalDisplayLayouts')({
  beforeLoad: async ({ context }) => {
    const authToken = getAuthtoken();
    if (!authToken) return;

    const response = await context.queryClient.ensureQueryData(
      currentUserQueryOptions(authToken)
    );
    if (!response?.success) throw redirect({ to: '/' });

    const user = response.message;
    if (!user.globalAdmin) throw redirect({ to: '/' });
  },
  component: ExternalDisplayEditor,
});
